module.exports = __webpack_public_path__ + "static/media/13.fe27b49a.mp3";